/**
 * 仕訳一覧の再取得トリガー（別タブ保存・同一ウィンドウのカスタムイベント用）
 */
const BROADCAST_NAME = 'kaikei-journal-list-sync';

export function notifyJournalListShouldRefresh(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent('kaikei-journal-saved'));
  try {
    const ch = new BroadcastChannel(BROADCAST_NAME);
    ch.postMessage({ type: 'invalidate' });
    ch.close();
  } catch {
    /* BroadcastChannel 非対応環境は無視 */
  }
}

export function subscribeJournalListRefresh(handler: () => void): () => void {
  const onCustom = () => handler();
  window.addEventListener('kaikei-journal-saved', onCustom);
  let bc: BroadcastChannel | null = null;
  try {
    bc = new BroadcastChannel(BROADCAST_NAME);
    bc.onmessage = () => handler();
  } catch {
    bc = null;
  }
  return () => {
    window.removeEventListener('kaikei-journal-saved', onCustom);
    bc?.close();
  };
}
